import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { ProfileFallbackAvatar } from '../profileFallbackAvatar/ProfileFallbackAvatar';
import styles from './styles.module.css';

const AvatarWithProfile = ({ localProfileId, avatar, name }) => (
    <div className="profile-identity-avatar">
        <a data-testid="profileLink" href={`/user/profile/profile.html?id=${localProfileId}`} className="profile-identity-avatar">
            {avatar ? (
                <img className="profile-identity-avatar_img" src={avatar} alt={name} />
            ) : (
                <div role="img" aria-label="Standard avatar når en bruker ikke har lastet opp eget bilde">
                    <ProfileFallbackAvatar className="profile-identity-avatar_img" />
                </div>
            )}
        </a>
    </div>
);
AvatarWithProfile.propTypes = {
    localProfileId: PropTypes.string,
    avatar: PropTypes.string,
    name: PropTypes.string,
};

const AvatarWithoutProfile = ({ avatar, name }) => (
    <div data-testid="profileNoLink" className="profile-identity-avatar">
        {avatar ? (
            <img className="profile-identity-avatar_img" src={avatar} alt={name} />
        ) : (
            <div role="img" aria-label="Bilde av en anonym avatar">
                <ProfileFallbackAvatar className="profile-identity-avatar_img" />
            </div>
        )}
    </div>
);
AvatarWithoutProfile.propTypes = {
    avatar: PropTypes.string,
    name: PropTypes.string,
};

export const ProfilePublic = ({ identity }) => (
    <div className={styles.ProfilePublic}>
        <div role="heading" aria-level="2" className={styles.heading}>
            Profilinformasjon om selgeren
        </div>
        {identity?.localProfileId ? <AvatarWithProfile {...identity} /> : <AvatarWithoutProfile {...identity} />}
        <div className={styles.container}>
            <div className={styles.identity}>
                {identity ? (
                    <a href={`/user/profile/profile.html?id=${identity.localProfileId}`} className={cn(styles.link, 'profile-link')}>
                        <div data-testid="profileName">{identity.name}</div>
                    </a>
                ) : (
                    <div data-testid="profileName">FINN-bruker</div>
                )}
                {identity?.verified ? (
                    <a data-testid="verifiedUser" href="/eid/verification.html">
                        <div role="img" aria-label="Verifisert bruker">
                            <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" height="32px" width="32px">
                                <g fill="none" fillRule="evenodd">
                                    <path fill="#0063FB" d="M3 4.545L9 2l6 2.545C15 9 15 14.091 9 16 3 14.09 3 9 3 4.545z" />
                                    <path
                                        fill="#FFF"
                                        fillRule="nonzero"
                                        d="M6.877 7.417L5.5 8.771 8.276 11.5 12.5 7.354 11.125 6 8.277 8.794z"
                                    />
                                </g>
                            </svg>
                        </div>
                    </a>
                ) : null}
            </div>
            {identity?.memberSince && moment(identity.memberSince).isValid() ? (
                <div data-testid="memberSince" className="text-14">
                    Har vært på FINN siden {moment(identity.memberSince).year()}
                </div>
            ) : null}
        </div>
    </div>
);

ProfilePublic.propTypes = {
    identity: PropTypes.object,
};
